<h1 mat-dialog-title>New App Update is Available</h1>
<div mat-dialog-content>
  Press 'Install' to update Now.
  Pressing 'Dismiss' will install the update on the next refresh.
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Dismiss</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button>
</mat-dialog-actions>